import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { Depot } from 'depoto-core/src/entities'
import { HistoryUtil, SchemaUtil } from '../../utils'
import { CoreService, NotificationService } from '../../services'
import { CheckDataChanges } from '../../services/can-deactivate-guard.service'
import { TranslateService } from '@ngx-translate/core'

import * as Sentry from '@sentry/angular-ivy'

@Component({
  selector: 'app-depot',
  templateUrl: 'depot.component.html',
})
export class DepotComponent implements OnInit, CheckDataChanges {
  depot: Depot
  isCreating = false
  loading = true
  depotForm = new UntypedFormGroup({
    name: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
  })
  submitted = false

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private core: CoreService,
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id']
    if (isNaN(id)) {
      this.isCreating = true
      this.depot = new Depot()
      this.loading = false
    } else {
      this.refreshData(id)
    }
  }

  hasUnsavedDataChanges(): boolean {
    return false
  }

  async refreshData(id: number) {
    this.loading = true
    const result = await this.core.services.depot.getById(id, SchemaUtil.depot)
    this.loading = false
    if (result) {
      this.depot = new Depot(result)
      this.depotForm.setValue({ name: this.depot.name })
    }
  }

  async createDepot(): Promise<void> {
    this.submitted = true
    if (this.depotForm.invalid) {
      return
    }
    this.depot.name = this.depotForm.value.name
    this.loading = true
    try {
      this.depot = await this.core.services.depot.create(this.depot)
      this.notificationService.success(this.translateService.instant('alert.depot.created'))
      this.router.navigate(['/depot/', this.depot.id])
    } catch (err) {
      console.log(err)
    } finally {
      this.loading = false
    }
  }

  async updateDepot() {
    this.submitted = true
    if (this.depotForm.invalid) {
      return
    }
    this.depot.name = this.depotForm.value.name
    try {
      const result = await this.core.services.depot.update(this.depot)
      this.notificationService.success(this.translateService.instant('alert.depot.updated'))
      await this.refreshData(result.id)
    } catch (err) {
      console.log(err)
    }
  }

  async deleteDepot() {
    const confirmation = confirm(this.translateService.instant('depot.delete.confirmation', { name: this.depot.name }))
    if (confirmation) {
      try {
        await this.core.services.depot.delete(this.depot)
        this.notificationService.success(this.translateService.instant('alert.depot.deleted'))
        HistoryUtil.navigateBack()
      } catch (err) {
        console.log(err)
      }
    }
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.depotForm.controls
  }

  triggerBackBtn() {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      this.router.navigate(['/depots'])
    }
  }
}
